<template>
    <span v-if="ShowButtons" class="dropdown ">
        <a class="btn btn-primary-t dropdown-toggle dropdown-toggle-ll" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false"></a>
        <ul class="dropdown-menu dropdown-menu-end">
            <slot name="bodyBtnsL"></slot>
        </ul>
    </span>
</template>

<script>

export default {
    name:  "CMoreButtonsList",
    props: ["pShowButtons"],
    data() {
        return {
            ShowButtons: true,
        }
    },
    computed: {
        ValidateLoad()
        {
            if (this.pShowButtons != undefined) {
                this.ShowButtons = this.pShowButtons;
            }
        }
    }
}
</script>